import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.guide');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-guide',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.guide/view.scss */
/* src/app/page.guide/view.scss: no such file or directory */`],
})
export class PageGuideComponent implements OnInit, OnDestroy {
    public step: string = '';
    private routerSub: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.step = WizRoute.segment.step || '';
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newStep = WizRoute.segment.step || '';
                if (newStep !== this.step) {
                    this.step = newStep;
                    await this.service.render();
                }
            }
        });
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public navigate(step: string) {
        this.service.href(`/guide/${step}`);
    }

    public goBack() {
        this.service.href('/guide');
    }

    public steps = [
        {
            id: 'infra',
            number: '01',
            title: 'Infra 환경 설정',
            subtitle: 'Project & Deploy 생성',
            description: 'Infra에서 프로젝트를 생성하고, Host/IP를 할당한 뒤 Deploy를 구성합니다.',
            icon: 'server',
            color: 'indigo',
            items: ['프로젝트 생성', 'Host & IP 할당', 'Deploy 구성']
        },
        {
            id: 'agent',
            number: '02',
            title: 'Wiz Agent 설정',
            subtitle: 'Chrome & VSCode Extension',
            description: 'Chrome 확장프로그램과 VSCode Extension을 설치하여 개발 환경을 구성합니다.',
            icon: 'code',
            color: 'violet',
            items: ['Chrome Extension 설치', 'VSCode Extension 설치', '샘플 프로젝트 빌드']
        },
        {
            id: 'workflow',
            number: '03',
            title: '프로젝트 수행',
            subtitle: 'TODO 기반 워크플로우',
            description: 'TODO 작성부터 작업 요청, 리뷰, 정리까지 일관된 워크플로우로 작업합니다.',
            icon: 'workflow',
            color: 'emerald',
            items: ['TODO 작성', '작업 요청', '리뷰 & 정리']
        }
    ];
}

export default PageGuideComponent;